(function () {
    'use strict';

    angular.module("imApp").factory("stocksOnLocationService", ['$ihttp', function ($ihttp) {
        let service = {
            getInfo: function (parms) {
                return $ihttp.post({
                    method: 1070,
                    parameters: parms || {}
                });
            },
            listStocksOnLocation: function (parms) {
                return $ihttp.post({
                    method: 1069,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
